import { defineConfig } from './config.default'

export default defineConfig({
	environment: 'production',
	
	maintenance: {
		message: undefined
	},
})